<div
  class="world-map-wrapper"
  [style.height]="data?.height || null"
  [style.max-height]="data?.maxHeight || data?.height || null"
  [class.screen-1-layout]="isScreen1View"
  [class.screen-2-layout]="isScreen2View"
  [class.screen-3-layout]="isScreen3View">
  <h4 class="world-map-title" *ngIf="data?.title">{{ data.title }}</h4>

  <div class="world-map-inner">
    <div class="viewing-label" *ngIf="selectedContinentLabel">
      <span class="location-icon-wrapper">
        <svg
          class="location-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      </span>
      Viewing: {{ selectedContinentLabel }}
    </div>

    @if(data?.customPayload?.filter) {
      <div class="world-map-sidebar">
        <app-global-filter [config]="data.customPayload.filter"></app-global-filter>
      </div>
    }

    <div id="{{ data.widgetId }}" class="world-map-container"></div>

    <div
      class="risk-legend-wrapper"
      *ngIf="showRiskLegend"
      [style.bottom.px]="data?.riskLegendBottomPx"
      [style.left.%]="data?.riskLegendLeftPercent"
      [style.right.px]="data?.riskLegendRightPx"
      [style.height.px]="data?.riskLegendHeightPx"
      [style.minHeight.px]="data?.riskLegendMinHeightPx">
      <h4 class="legend-title">Repower Risk (% of mines)</h4>
      <div class="legend-body">
        <div class="legend-scale-row">
          <div
            class="legend-seg seg-active-repower"
            [class.seg-active]="activeRiskFilter === 'active'"
            (click)="toggleRiskFilter('active')">
            <img class="legend-seg-fire-icon" [src]="activeLegendFireIcon" alt="" aria-hidden="true" />
            <span class="legend-seg-value">{{ getLegendValueLabel('active') }}</span>
          </div>
          <div
            class="legend-seg seg-high"
            [style.background]="getLegendColor('high')"
            [class.seg-active]="activeRiskFilter === 'high'"
            (click)="toggleRiskFilter('high')">
            <span class="legend-seg-value">{{ getLegendValueLabel('high') }}</span>
          </div>
          <div
            class="legend-seg seg-medium"
            [style.background]="getLegendColor('medium')"
            [class.seg-active]="activeRiskFilter === 'medium'"
            (click)="toggleRiskFilter('medium')">
            <span class="legend-seg-value">{{ getLegendValueLabel('medium') }}</span>
          </div>
          <div
            class="legend-seg seg-low"
            [style.background]="getLegendColor('low')"
            [class.seg-active]="activeRiskFilter === 'low'"
            (click)="toggleRiskFilter('low')">
            <span class="legend-seg-value">{{ getLegendValueLabel('low') }}</span>
          </div>
          <div
            class="legend-seg seg-inactive"
            [style.background]="getLegendColor('inactive')"
            [class.seg-active]="activeRiskFilter === 'inactive'"
            (click)="toggleRiskFilter('inactive')">
            <span class="legend-seg-value">{{ getLegendValueLabel('inactive') }}</span>
          </div>
        </div>
        <div class="legend-labels">
          <span class="lbl lbl-active"><span>Active</span><span>Repowers</span></span>
          <span class="lbl lbl-high">High</span>
          <span class="lbl lbl-medium">Medium</span>
          <span class="lbl lbl-low">Low</span>
          <span class="lbl lbl-inactive">Inactive</span>
        </div>
      </div>
    </div>

    <div class="world-map-note" *ngIf="data?.note">
      {{ data.note }}
    </div>
  </div>
</div>
